import { Icon } from '../components/Icon';
import { useConfig, useMe } from '../data/store';
import { euro } from '../data/helpers';
import type { Integration } from '../data/types';

const INT_STATUS: Record<Integration['status'], { label: string; cls: string }> = {
  connected: { label: 'Collegato', cls: 'st-ok' },
  warning: { label: 'Attenzione', cls: 'st-work' },
  off: { label: 'Non collegato', cls: 'st-draft' },
};

export function SettingsView() {
  const { plans, integrations } = useConfig();
  const me = useMe();

  return (
    <div className="view">
      <div className="view-pad rs-stack" style={{ maxWidth: 820 }}>
        {/* studio */}
        <div className="rs-card">
          <div className="rs-card-head">
            <span className="rs-card-title">Studio</span>
          </div>
          <div className="rs-dl">
            <Row k="Nome" v="Risma Studio" />
            <Row k="Email" v="info@rismastudio.it" />
            <Row k="Dominio" v="rismastudio.it" />
            <Row k="Operatore" v={me?.name ?? me?.email ?? '—'} />
          </div>
        </div>

        {/* plans */}
        <div className="rs-card">
          <div className="rs-card-head">
            <span className="rs-card-title">Piani</span>
          </div>
          <div className="rs-stack" style={{ gap: 10 }}>
            {plans.map((p) => (
              <div key={p.id} className="rs-dl-row" style={{ alignItems: 'flex-start' }}>
                <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink)' }}>{p.name}</span>
                  <span className="rs-mini-meta">{p.blurb}</span>
                </span>
                <span className="rs-dl-v" style={{ whiteSpace: 'nowrap' }}>
                  {euro(p.price)}/mese · setup {euro(p.setup)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* integrations */}
        <div className="rs-card">
          <div className="rs-card-head">
            <span className="rs-card-title">Integrazioni</span>
          </div>
          <div className="rs-dl">
            {integrations.map((it) => {
              const s = INT_STATUS[it.status];
              return (
                <div className="rs-dl-row" key={it.id}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                    <span className="rs-feed-ico">
                      <Icon name="spark" size={15} />
                    </span>
                    <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                      <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--ink)' }}>{it.name}</span>
                      <span className="rs-mini-meta">{it.detail}</span>
                    </span>
                  </span>
                  <span className={'rs-chip ' + s.cls}>{s.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ k, v }: { k: string; v: string }) {
  return (
    <div className="rs-dl-row">
      <span className="rs-dl-k">{k}</span>
      <span className="rs-dl-v">{v}</span>
    </div>
  );
}
